module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.isDisabled) ? _c('div', {
    staticClass: "form-error-msg"
  }, [_c('span', {
    staticClass: "error"
  }, [_vm._v("* You need to review the mandatory fields before you can save.")])]) : _vm._e(), _vm._v(" "), (_vm.showButtons) ? _c('div', {
    staticClass: "d-flex justify-content-end align-items-center my-1 py-2"
  }, [_c('button', {
    staticClass: "btn cancel wider mr-3",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn cancel wider mr-3",
    on: {
      "click": _vm.back
    }
  }, [_vm._v("Back")]), _vm._v(" "), (_vm.showExistingAgentSelector) ? _c('button', {
    staticClass: "btn green wider mr-3",
    attrs: {
      "disabled": _vm.isDisabled
    },
    on: {
      "click": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("Send")]) : (!_vm.form.saveAndSend) ? _c('button', {
    staticClass: "btn green wider mr-3",
    attrs: {
      "disabled": _vm.isDisabled
    },
    on: {
      "click": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("Save")]) : (_vm.form.saveAndSend) ? _c('button', {
    staticClass: "btn green wider",
    attrs: {
      "disabled": _vm.isDisabled
    },
    on: {
      "click": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("Invite")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "micro-tabs-content mt-0"
  }, [(_vm.activeTab === 0) ? _c('div', [_c('div', [_c('div', {
    staticClass: "form-group row"
  }, [(_vm.payments) ? _c('div', {
    staticClass: "col-sm-12"
  }, [_c('h5', [_vm._v("Payment Protocol")]), _vm._v(" "), _c('label', {
    staticClass: "full"
  }, [_vm._v("Amount received by the agent")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "disabled": _vm.disableInputs,
      "options": _vm.payments,
      "label": "description",
      "placeholder": "- Select payment -"
    },
    on: {
      "input": _vm.updatePayment
    },
    model: {
      value: (_vm.selectedPayment),
      callback: function($$v) {
        _vm.selectedPayment = $$v
      },
      expression: "selectedPayment"
    }
  })], 1) : _vm._e()]), _vm._v(" "), (_vm.payments && _vm.form.payment == 2) ? _c('div', {
    staticClass: "form-group row"
  }, [(_vm.deposits) ? _c('div', {
    staticClass: "col-sm-8"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("Deposit")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "disabled": _vm.disableInputs,
      "options": _vm.deposits,
      "label": "description",
      "placeholder": "- Select deposit -"
    },
    on: {
      "input": _vm.updateDeposit
    },
    model: {
      value: (_vm.selectedDeposit),
      callback: function($$v) {
        _vm.selectedDeposit = $$v
      },
      expression: "selectedDeposit"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "fs-smaller mt-2 dark"
  }, [_vm._v("\n                            This is the deposit that the customer must pay at the time of booking.\n                        ")])], 1) : _vm._e(), _vm._v(" "), (_vm.showDepositValue) ? _c('div', {
    staticClass: "col-sm-4"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("\n                             \n\n                            "), _c('div', {
    staticClass: "d-flex"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.form.depositValue),
      expression: "form.depositValue",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "glued-right",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.form.depositValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "depositValue", _vm._n($event.target.value))
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "glued-left glued-left-min-width"
  }, [_vm._v(_vm._s(_vm.selectedDeposit.symbol))])])])]) : _vm._e()]) : _vm._e()]), _vm._v(" "), (_vm.loadingCommissions) ? _c('div', {
    staticClass: "text-center p-4"
  }, [_c('loader')], 1) : _vm._e(), _vm._v(" "), (!_vm.loadingCommissions && _vm.form.commission.commissionRelations.length == 0) ? _c('div', {
    staticClass: "text-center p-4 dark font-weight-600 fs-large"
  }, [_vm._v("\n                You have no products on your account\n            ")]) : _c('div', [(_vm.form.commission && !_vm.loadingCommissions) ? _c('table', {
    staticClass: "table shaded commissions fs-normal"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_c('tr', {
    staticClass: "hidden"
  }, [_c('td', [_vm._v("Standard commission (%)")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.commission.productAmountValue),
      expression: "form.commission.productAmountValue"
    }],
    attrs: {
      "type": "number",
      "disabled": _vm.disableInputs
    },
    domProps: {
      "value": (_vm.form.commission.productAmountValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form.commission, "productAmountValue", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _vm._l((_vm.form.commission.commissionRelations), function(commission) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(commission.productName))]), _vm._v(" "), _c('td', {
      staticClass: "value",
      staticStyle: {
        "width": "80px"
      }
    }, [_c('div', {
      staticClass: "d-flex",
      staticStyle: {
        "width": "115px"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (commission.productAmountValue),
        expression: "commission.productAmountValue"
      }],
      staticClass: "glued-right",
      staticStyle: {
        "width": "65px"
      },
      attrs: {
        "type": "number",
        "disabled": _vm.disableInputs
      },
      domProps: {
        "value": (commission.productAmountValue)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(commission, "productAmountValue", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('v-select', {
      staticClass: "glued-left",
      staticStyle: {
        "width": "50px"
      },
      attrs: {
        "disabled": _vm.disableInputs,
        "options": _vm.getPercentageOrCurrency
      },
      on: {
        "input": function($event) {
          return _vm.commissionTypeChanged($event, commission, 'productAmountType')
        }
      },
      model: {
        value: (commission.productAmountType_helper_selected),
        callback: function($$v) {
          _vm.$set(commission, "productAmountType_helper_selected", $$v)
        },
        expression: "commission.productAmountType_helper_selected"
      }
    })], 1)]), _vm._v(" "), _c('td', {
      staticClass: "value",
      staticStyle: {
        "width": "80px"
      }
    }, [_c('div', {
      staticClass: "d-flex",
      staticStyle: {
        "width": "115px"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (commission.componentAmountValue),
        expression: "commission.componentAmountValue"
      }],
      staticClass: "glued-right",
      staticStyle: {
        "width": "65px"
      },
      attrs: {
        "type": "number",
        "disabled": _vm.disableInputs
      },
      domProps: {
        "value": (commission.componentAmountValue)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(commission, "componentAmountValue", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('v-select', {
      staticClass: "glued-left",
      staticStyle: {
        "width": "50px"
      },
      attrs: {
        "disabled": _vm.disableInputs,
        "options": _vm.getPercentageOrCurrency
      },
      on: {
        "input": function($event) {
          return _vm.commissionTypeChanged($event, commission, 'componentAmountType')
        }
      },
      model: {
        value: (commission.componentAmountType_helper_selected),
        callback: function($$v) {
          _vm.$set(commission, "componentAmountType_helper_selected", $$v)
        },
        expression: "commission.componentAmountType_helper_selected"
      }
    })], 1)])])
  })], 2)]) : _vm._e()])]) : (_vm.activeTab === 1) ? _c('div', [_vm._v("\n            This information is not available yet.\n        ")]) : _c('div', [_vm._v("\n            This information is not available yet.\n        ")])]), _vm._v(" "), (_vm.showButtons) ? _c('div', {
    staticClass: "d-flex justify-content-end align-items-center my-1 py-2"
  }, [_c('button', {
    staticClass: "btn cancel wider mr-3",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn cancel wider mr-3",
    on: {
      "click": _vm.back
    }
  }, [_vm._v("Back")]), _vm._v(" "), (_vm.showExistingAgentSelector) ? _c('button', {
    staticClass: "btn green wider mr-3",
    attrs: {
      "disabled": _vm.isDisabled
    },
    on: {
      "click": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("Send")]) : (!_vm.form.saveAndSend) ? _c('button', {
    staticClass: "btn green wider mr-3",
    attrs: {
      "disabled": _vm.isDisabled
    },
    on: {
      "click": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("Save")]) : (_vm.form.saveAndSend) ? _c('button', {
    staticClass: "btn green wider",
    attrs: {
      "disabled": _vm.isDisabled
    },
    on: {
      "click": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("Invite")]) : _vm._e()]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th'), _vm._v(" "), _c('th', {
    staticClass: "value text-center",
    staticStyle: {
      "width": "100px"
    }
  }, [_vm._v("Product")]), _vm._v(" "), _c('th', {
    staticClass: "value text-center",
    staticStyle: {
      "width": "100px"
    }
  }, [_vm._v("Extras")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-6593608c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6593608c"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/people/agents/AgentCommissions.vue
// module id = 1239
// module chunks = 0